<template>
    <div>
        <v-data-table
            :options.sync="options"
            :headers="headers"
            :items="items"
            :items-per-page="options.itemsPerPage"
            :loading="loading"
            :server-items-length="total"
            :footer-props="{
                itemsPerPageOptions: [10, 25, 50],
            }"
            v-bind="$attrs"
            v-model="selection"
            @click:row="e => $emit('click:row', e)"
        >
            <template v-for="header in headers" v-slot:[`header.${header.value}`]="slotProps">
                <template v-if="$scopedSlots[`header.${header.value}`] || $slots[`header.${header.value}`]">
                    <slot :name="`header.${header.value}`" v-bind="slotProps" />
                </template>
                <template v-else>
                    {{ header.text }}
                </template>
            </template>

            <template v-for="header in headers" v-slot:[`item.${header.value}`]="slotProps">
                <template v-if="$scopedSlots[`item.${header.value}`]">
                    <slot :name="`item.${header.value}`" v-bind="slotProps"></slot>
                </template>
                <template v-else> {{ slotProps.item[header.value] }} </template>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import { debounce } from 'lodash';
export default {
    props: {
        headers: {
            type: Array,
            required: true,
        },
        fetchFunction: {
            type: Function,
            required: true,
        },
        fetchArgs: {
            type: [Object, Function],
            default: () => ({}),
        },
    },

    data() {
        return {
            options: {
                page: 1,
                itemsPerPage: 10,
                sortBy: [],
                sortDesc: [],
            },
            items: [],
            loading: false,
            total: 0,
            selection: [],
        };
    },
    watch: {
        options: {
            deep: true,
            handler() {
                this.debouncedFetchData();
            },
        },
        selection(newVal) {
            this.$emit('change:selection', newVal);
        },
    },
    methods: {
        async fetchData() {
            this.loading = true;

            try {
                const { page, itemsPerPage, sortBy, sortDesc } = this.options;

                const paginationParams = {
                    pageNumber: page > 0 ? page - 1 : 0,
                    pageSize: itemsPerPage,
                    sortBy: sortBy.length > 0 ? sortBy[0] : 'id',
                    sortAsc: sortDesc.length > 0 ? !sortDesc[0] : false,
                };

                const extraArgs = typeof this.fetchArgs === 'function' ? this.fetchArgs() : this.fetchArgs;

                const result = await this.fetchFunction(Object.assign({}, paginationParams, extraArgs));

                this.items = result.responses || result.items || [];
                this.total = typeof result.total === 'number' ? result.total : 0;
                this.selection = [];
            } catch (err) {
                console.error('[BasePaginatedTable] Fetch error:', err);
            } finally {
                this.loading = false;
            }
        },
    },
    created() {
        this.debouncedFetchData = debounce(this.fetchData, 200);
    },
    mounted() {
        this.debouncedFetchData();
    },
};
</script>
